import { render, staticRenderFns } from "./detail-header.vue?vue&type=template&id=d8fc72a0&scoped=true"
import script from "./detail-header.vue?vue&type=script&lang=js"
export * from "./detail-header.vue?vue&type=script&lang=js"
import style0 from "./detail-header.vue?vue&type=style&index=0&id=d8fc72a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fc72a0",
  null
  
)

export default component.exports